export const filterUsers = (arr, isCognitoUsers = false) =>
  (arr ?? [])?.filter(user => (isCognitoUsers ? ['MM_Cognito', 'Cognito']?.includes(user?.group_name) : !['MM_Cognito', 'Cognito']?.includes(user?.group_name)));
